// validateCpf.ts
export function validateCpf(strCPF: string): boolean {
  const sum: { value: number } = ref(0);
  const remnant: { value: number } = ref(0);

  sum.value = 0;
  if (
    strCPF === '00000000000' ||
    strCPF.length !== 11 ||
    /^(\d)\1+$/.test(strCPF)
  ) {
    return false;
  }

  for (let i = 1; i <= 9; i++)
    sum.value += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  remnant.value = (sum.value * 10) % 11;

  if (remnant.value === 10 || remnant.value === 11) remnant.value = 0;
  if (remnant.value !== parseInt(strCPF.substring(9, 10))) {
    return false;
  }

  sum.value = 0;
  for (let i = 1; i <= 10; i++)
    sum.value += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  remnant.value = (sum.value * 10) % 11;

  if (remnant.value === 10 || remnant.value === 11) remnant.value = 0;
  if (remnant.value !== parseInt(strCPF.substring(10, 11))) {
    return false;
  }

  return true;
}

export function cpfMask(cpf: string) {
  if (!cpf || cpf === '') return '';

  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/gi, '$1.$2.$3-$4');
}
